import React, { useState, useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import * as routerSelectors from 'app/selectors/router';
import FailureState from 'app/components/customer/dashboard/FailureState';
import { AvailableProducts, UserSelectedWarriorSubProductMapping } from 'app/constants/Products';
import Step0 from './Step0';
import Step1 from './Step1';
import NameStep from '../Parts/Step3';
import DrawerMenu from 'app/components/common/DrawerMenu';
import { Drawer, NavBar, PageWrapper } from 'mui';
import LoginType from 'app/components/customer/Registration/Parts/LoginType';

const mapStateToProps = (state) => {
  const feedbackParam = routerSelectors.selectRouterQuery(state).get('registration_feedback');
  const testMode = routerSelectors.selectRouterQuery(state).get('test_mode');

  const subProduct = (() => {
    const sub_product = routerSelectors.selectRouterQuery(state).get('sub_product');

    return Object.keys(UserSelectedWarriorSubProductMapping).find((key) =>
      UserSelectedWarriorSubProductMapping[key].includes(sub_product),
    );
  })();

  return {
    feedbackParam,
    initialValues: {
      settings: {
        product: AvailableProducts.Warrior,
        test_mode: testMode,
        sub_product: subProduct,
      },
      step0: {},
      step1: {
        state: '',
        pc_opt_in: false,
        mso_opt_in: false,
        over_18: false,
      },
      step2: {
        first_name: '',
        last_name: '',
      },
      step3: {
        email: window.emailFromTypeform,
        password: '',
        password_confirmation: '',
      },
    },
  };
};

const WarriorRegistration = ({ feedbackParam, initialValues, experimentVariant }) => {
  // eslint-disable-next-line @typescript-eslint/ban-types
  const [allValues, setAllValues] = useState(initialValues);
  const [currentStep, setCurrentStep] = useState(0);
  const stepValue = allValues[`step${currentStep}`];

  const onSubmitNextStep = useCallback(
    (values) => {
      setAllValues((allValues) => ({
        ...allValues,
        [`step${currentStep}`]: values,
      }));
      setCurrentStep(currentStep + 1);
    },
    [currentStep],
  );

  const content = useMemo(
    () => (
      <>
        {currentStep === 0 && <Step0 onSubmit={onSubmitNextStep} />}
        {currentStep === 1 && (
          <Step1 initialValues={stepValue} onSubmit={onSubmitNextStep} experimentVariant={experimentVariant} />
        )}
        {currentStep === 2 && <NameStep initialValues={stepValue} onSubmit={onSubmitNextStep} />}
        {currentStep === 3 && <LoginType allValues={allValues} />}
      </>
    ),
    [currentStep, onSubmitNextStep, stepValue, experimentVariant],
  );

  if (feedbackParam) {
    return (
      <Drawer sideContent={<DrawerMenu loggedIn={false} />}>
        <NavBar />
        <FailureState state={feedbackParam} />
      </Drawer>
    );
  }

  return <PageWrapper>{content}</PageWrapper>;
};

export default connect(mapStateToProps)(WarriorRegistration);
